/* global axios */
import ApiClient from './ApiClient';

const positiveIntegerPathSegment = (value, name) => {
  const normalizedValue = String(value ?? '').trim();
  if (!/^[1-9]\d*$/.test(normalizedValue)) {
    throw new TypeError(`${name} must be a positive integer`);
  }
  return encodeURIComponent(normalizedValue);
};

class PipelineFollowUpRulesAPI extends ApiClient {
  constructor() {
    super('follow-up-rules', { accountScoped: true });
  }

  getUrl(pipelineId, accountId) {
    return `${this.apiVersion}/accounts/${positiveIntegerPathSegment(
      accountId,
      'accountId'
    )}/pipelines/${positiveIntegerPathSegment(
      pipelineId,
      'pipelineId'
    )}/follow-up-rules`;
  }

  get(pipelineId, accountId) {
    const requestUrl = this.getUrl(pipelineId, accountId);
    return axios.get(requestUrl);
  }

  show(pipelineId, ruleId, accountId) {
    const requestUrl = `${this.getUrl(
      pipelineId,
      accountId
    )}/${positiveIntegerPathSegment(ruleId, 'ruleId')}`;
    return axios.get(requestUrl);
  }

  create(pipelineId, data, accountId) {
    const requestUrl = this.getUrl(pipelineId, accountId);
    return axios.post(requestUrl, {
      pipeline_follow_up_rule: data,
    });
  }

  update(pipelineId, ruleId, data, accountId) {
    const requestUrl = `${this.getUrl(
      pipelineId,
      accountId
    )}/${positiveIntegerPathSegment(ruleId, 'ruleId')}`;
    return axios.patch(requestUrl, {
      pipeline_follow_up_rule: data,
    });
  }

  delete(pipelineId, ruleId, accountId) {
    const requestUrl = `${this.getUrl(
      pipelineId,
      accountId
    )}/${positiveIntegerPathSegment(ruleId, 'ruleId')}`;
    return axios.delete(requestUrl);
  }
}

export default new PipelineFollowUpRulesAPI();
